// Port de app/(tabs)/checklists.tsx.
import { Carregando } from "@/app/Carregando";
import { useIsFocused } from "@/navigation";
import { lazy } from "react";

const ChecklistsScreen = lazy(() => import("@/screens/Checklists"));

export default function ChecklistsRoute() {
  const focused = useIsFocused();
  return focused ? (
    <Carregando>
      <ChecklistsScreen />
    </Carregando>
  ) : null;
}
